'use client';

import { Slider as ChakraSlider } from '@chakra-ui/react';
import * as React from 'react';

export interface SliderProps extends ChakraSlider.RootProps {
  label?: React.ReactNode;
  showValue?: boolean;
}

export const Slider = React.forwardRef<HTMLDivElement, SliderProps>(
  function Slider(props, ref) {
    const { label, showValue, ...rest } = props;
    return (
      <ChakraSlider.Root ref={ref} {...rest}>
        {label && (
          <ChakraSlider.Label>
            {label}
            {showValue && <ChakraSlider.ValueText />}
          </ChakraSlider.Label>
        )}
        <ChakraSlider.Control>
          <ChakraSlider.Track>
            <ChakraSlider.Range />
          </ChakraSlider.Track>
          <ChakraSlider.Thumbs />
        </ChakraSlider.Control>
      </ChakraSlider.Root>
    );
  },
);
